import React, { Component } from 'react';
import $ from 'jquery';
import Config from './Config';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem, InputGroup, Input } from 'reactstrap';
import { BrowserRouter as Router, Route, Link } from 'react-router-dom';
import Header from '../components/Header';
import Editor from '../components/Editor';
import NewReportModal from '../components/modals/NewReportModal';
import TemplateEditorModal from '../components/modals/TemplateEditorModal'
import TemplateTable from '../components/tables/TemplateTable'
import { connect } from 'react-redux';
import AuthHOC from './Auth';
import { withAlert } from 'react-alert';
import { Flag } from 'flagger/react';
import { Stack, Typography, Button as MuiButton } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

class DesignerView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dropdownOpen: false,
      templates: [],
      associated_templates: [],
      displayTemplateEditorModal: false,
      displaynewReportModal: false
    };
  }

  componentDidMount() {
    this.refresh();
  }

  refresh = () => {
    fetch(window.location.protocol + '//' + window.location.host + '/api/email/get_email_templates')
      .then(res => res.json())
      .then(result => {
        this.setState({
          templates: result,
          associated_templates: []
        })
      })
  }

  toggle = () => {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen
    });
    this.refresh();
  }

  onDropDownclick = (event) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    let template = this.state.templates.find(element => {
      return element.template == name
    })

    this.setState({
      template: template.template,
      html: template.html
    })
  }

  handleInputChange = (html) => {
    this.setState({
      html: html
    })
  }

  handleRawInputChange = (html) => {
    this.setState({
      rawhtml: html
    })
  }

  activateHtmlButton = () => {
    this.setState({
      text: !this.state.text
    })
  }

  showNewReportModal = () => {
    this.setState({
      displaynewReportModal: !this.state.displaynewReportModal
    })
  }

  showTemplateEditorModal = () => {
    this.setState({
      displayTemplateEditorModal: !this.state.displayTemplateEditorModal
    })
  }

  expandLogs = (file) => {
    let id = file.parentId ? file.parentId : file._id

    var found = this.state.associated_templates.find(element => {
      return element.id == id;
    });

    if (found) {
      this.setState(prevState => ({
        associated_templates: prevState.associated_templates.filter(j => found !== j)
      }))
    }
    else {
      fetch(window.location.protocol + '//' + window.location.host + '/api/email/get_email_template_chlidren?id=' + id)
        .then(res => res.json())
        .then(result => {
          if (!result.empty) {
            result.sort((a, b) => b.version - a.version);
            this.setState(prevState => ({
              associated_templates: prevState.associated_templates.concat({
                id: file.parentId ? file.parentId : file._id,
                associated: result
              })
            }));
          }
        })
    }
  }

  render() {

    let newreportmodel = {}
    let templateReportModal = {}

    if (this.state.displaynewReportModal) {
      newreportmodel = <NewReportModal visible={this.state.displaynewReportModal} toggle={this.showNewReportModal} refresh={this.refresh} />
      templateReportModal = <NewReportModal visible={this.state.displaynewReportModal} toggle={this.showNewReportModal} refresh={this.refresh} useFilteredTemplates={true} />
    }
    else {
      templateReportModal = <div />
      newreportmodel = <div />
    }


    return (
      <div className="App">
        <Header visible={!this.props.parsed.X3} />
        <div className="page-wrapper">
        <div className="s-page">
          <div className="s-page-header">
            <Stack spacing={0.5} alignItems="flex-start" sx={{ mb: 3, textAlign: "left" }}>
              <Typography variant="h5" sx={{ fontWeight: 600 }}>
                {this.props.localisation['menu_header_email_template_designer'] ? this.props.localisation['menu_header_email_template_designer'].element_lang : 'Email Template Designer'}
              </Typography>
              <Typography variant="body1" color="text.secondary">
                Design and manage email templates
              </Typography>
            </Stack>
            <div className="s-page-actions">
              <MuiButton
                variant="contained"
                startIcon={<AddIcon />}
                disableElevation
                type="button"
                sx={{ textTransform: 'none' }}
                onClick={this.showNewReportModal}
              >
                {this.props.localisation['template_new_report'] ? this.props.localisation['template_new_report'].element_lang : ''}
              </MuiButton>
            </div>
          </div>
          <div className="s-content-panel">
          <InputGroup>
            <div className="text-editor" style={{ width: '100%' }}>
              <TemplateTable
                delete={this.remove}
                refresh={this.refresh}
                onRowClicked={this.rowClicked}
                logs={this.state.templates}
                associated_templates={this.state.associated_templates}
                expandLogs={this.expandLogs}
                useFilteredTemplates={true}
                columnConfig={{ expand: true, actions: true }}
              />
            </div>
          </InputGroup>
          {templateReportModal}
          </div>
        </div>
        </div>
      </div>
    );
  }
}

export default connect(state => state)(AuthHOC(DesignerView, { name: 'email_template_designer' }));

